/**
 * DWT dependencies
 */

import LegalCopy from '../block-components/LegalCopy';
import { filterOutWhiteSpace } from '../utils/general-utils';
import { 
  circleEnvelopeIcon,
  defaultEnvelopeIcon,
  paperPlaneIcon,
  starEnvelopeIcon
} from '../../img/icons';

/**
 * WP dependencies
 */

import { RichText, useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';

const save = ({ attributes }) => {
  const {
    backgroundColor,
    image,
    borderColor,
    borderStyle,
    borderWidth,
    alt,
    heading,
    headingColor,
    text,
    textColor,
    legalText,
    legalTextColor,
    emailFieldColor
  } = attributes;

  const blockProps = useBlockProps.save({
    className: 'block__newsletter'
  });

  const innerBlocksProps = useInnerBlocksProps.save({
    className: 'newsletter__form'
  });

  const newsletterInnerClasses = filterOutWhiteSpace( [
    'newsletter--inner',
    borderStyle,
    borderWidth
  ] );
  
  const iconMap = {
    'circle-envelope': circleEnvelopeIcon,
    'default-envelope': defaultEnvelopeIcon,
    'star-envelope': starEnvelopeIcon,
    'paper-plane': paperPlaneIcon
  };
  const altText = alt ?? '';
  const outputImageTag = ( () => {
    if ( !image || image === 'Select an icon' ) return null;
    
    // Check if it's one of our predefined icons
    if ( iconMap[image] ) {
      return iconMap[image];
    }
    
    // Otherwise it's an uploaded image URL
    return <img src={image} alt={altText} />;
  })();

  const bgColor = backgroundColor ? { backgroundColor } : undefined;
  const bColor = borderColor ? { borderColor } : undefined;

  const hColor = headingColor ? { color: headingColor } : undefined;
  const tColor = textColor ? { color: textColor } : undefined;
  const ltColor = legalTextColor ? { color: legalTextColor } : undefined;
  const efColor = emailFieldColor ? { '--email-field-color': emailFieldColor } : undefined;

  return (
    <div { ...blockProps }>
      <div
        className={ newsletterInnerClasses }
        style={ { ...bgColor, ...bColor, ...efColor } }
      >
        <div className='newsletter-wrapper mx-auto flex flex-col has-success'>

          { image && (
            <div className='newsletter__image-wrapper'>
              { outputImageTag }
            </div>
          ) }

          { heading.length > 0 && (
            <RichText.Content
              className='heading-4 newsletter__heading'
              style={ { ...hColor } }
              tagName='h4'
              value={ heading }
            />
          ) }

          { text.length > 0 && (
            <RichText.Content
              className='paragraph-1 newsletter__text'
              style={ { ...tColor } }
              tagName='p'
              value={ text }
            />
          ) }

          {/* Block email-form */}
          <div { ...innerBlocksProps } />
          { legalText
            ? <RichText.Content
              className='paragraph-3 newsletter__legal'
              style={ { ...tColor } }
              tagName='p'
              value={ legalText }
            />
            : <LegalCopy
              className="paragraph-3 newsletter__legal"
              style={ { ...ltColor } }
            />
          }
        </div>
      </div>
    </div>
  );
};

export default save;
